import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { EdgeConfigQueries } from "@/api/edgeConfig/queries"
import {
  MaintenanceConfigParser,
  IMaintenanceConfigRaw,
} from "@/models/maintenanceConfig/maintenanceConfig.parser"
import { IMaintenanceConfig } from "@/models/maintenanceConfig/maintenanceConfig.types"

class MaintenanceServiceClass {
  getMaintenanceConfig(): QueryResult<IMaintenanceConfig | null> {
    return useQuery({
      ...EdgeConfigQueries.maintenance.config(),
      placeholderData: null,
      parserFn: (data) =>
        MaintenanceConfigParser.toDomain(data as IMaintenanceConfigRaw),
    })
  }
}

export const MaintenanceService = new MaintenanceServiceClass()
